export const SIGNALIZATION_SYSTEM = {
  DMI_STATUS_ERROR_1: 3,
  DMI_STATUS_ERROR_2: 4,
  STATUS: {
    BTM_ERROR: 1,
    JRU_ERROR: 1,
    RTM_ERROR: 1,
    EVC_ERROR: 1,
    NVC_ERROR: 1,
    PSU_ERROR: 1,
    DMI_ERROR: 1,
    DMI_TEMP_ERROR: 1,
    DMI_FAN_ERROR: 1,
    TACHO_BROKEN: 1,
    DOPPLER_BROKEN: 1
  }
} as const;
